import { render } from "./VideoCourses.vue?vue&type=template&id=7f31afa1"
import script from "./VideoCourses.vue?vue&type=script&lang=js"
export * from "./VideoCourses.vue?vue&type=script&lang=js"

import "./VideoCourses.vue?vue&type=style&index=0&id=7f31afa1&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__